<template>
  <div>
    <div class="header d-flex">
      <div @click="goToNews">
        <span>Back to News</span>
        <span>
          <v-icon name="chevron-left"></v-icon>
        </span>
      </div>
      <h1>UniBit Opinions</h1>
    </div>

    <div class="main-content">
      <!-- <div class="row opinion-news" v-for="(news, index) in assetNewsList.slice(0,3)" :key="index">
        <div class="col-3 pic">
            <img  :src="require('@/assets/imgs/google.png')" />
            <div>
                <span style="margin-right:10px">Bond</span>
                <span>ETF</span>
            </div>
            
        </div>
        <div class="col-9">
            <p id="NewsSource"> {{news.source}} | {{news.author}}</p>
            <p id="NewsTitle">
                <a :href="news.url" target="_blank" rel="noopener noreferrer">{{news.title}}</a>
                <a :href="news.tickerWebsite" target="_blank" rel="noopener noreferrer">
                  ({{news.ticker}})
                </a>
            </p>
            <p id="NewsContent">{{news.description}}</p>
            <p id="NewsDateTime">{{formatDateTime(news['publish at'])}}</p>
        </div>
      </div>-->
      <div v-if="!auth" class="login-hint text-right">
        <span>Log in to read more</span>
        <span>
          <v-icon name="chevron-down"></v-icon>
        </span>
      </div>
      <div class="row opinion-news" v-for="(item, index) in [1,2,3]" :key="index">
        <div class="col-3 pic">
          <img :src="require('@/assets/imgs/google.png')" />
          <div>
            <span style="margin-right:10px">Bond</span>
            <span>ETF</span>
          </div>
        </div>
        <div class="col-9" @click="showFullOpinion">
          <p id="NewsSource">UniBit | Vincent</p>
          <p
            id="NewsTitle"
          >What Stock Should you Buy if a Socialists Gets Elected to the White House?</p>
          <p v-if="show" id="NewsContent">
            Broad consensus on Wall Street is that if Elizabeth Warren or Bernie Sanders get elected to the White House, the Market will crash in monumental fashion. However, individual enterprise at various sectors may quite differently even governed by a socialistic government.
            Energy - Energy sector is experiencing secular decline as Wall Street embraces ESG. Oil price has been in a bear market even with production cut. The bear case for oil and gas will be likely to persist if a progressive leftist gets elected to the White House. Elizabeth Warren has threatened to ban fracking everywhere and is planning to fight climate change aggressively. This would lead to further capital outflow for energy sector.
            Financials - Famously for calling a break-up for big banks, Warren actually rose to Massachusetts Senate Seat in 2012 because of her strict policies against big banks. Similar to Warren’ stance, Sanders too wants to break up big banks that has higher than $584 billion market cap (3% of U.S. GDP in 2018). Both are very tough in financial regulations and would surely strike fear in the financial world if elected.
            Heathcare - Both Sanders and Warren champion for Medicare for All. Warren even wants to end private insurance once and for all. This would significantly disrupt private insurers such as CVS (CVS), Humana (HUM), and UnitedHealth (UNH). Pharmaceutical companies too may be negatively affected by these two candidates’ fierce stance in fighting drug prices.
            Technology - Not a big fan of Tech companies such as Google, and Facebook, Senator Warren actually details her plan for breaking up big tech firms in this article. Regulating big tech has become a hot topic in 2020 campaign and receives wide support within the Democratic Party including Andrew Yang. Already facing growth worries from the Wall Street, big tech companies are unlikely to even keep profits if broken up into pieces.
          </p>
          <p
            v-else
            id="NewsContent"
          >Broad consensus on Wall Street is that if Elizabeth Warren or Bernie Sanders get elected to the White House, the Market will crash in monumental fashion. However, individual enterprise at various sectors may quite differently even governed by a socialistic government...</p>
          <!-- <p id="NewsDateTime">{{formatDateTime(news['publish at'])}}</p> -->
        </div>
      </div>
      <div class="footer-links">
        <p @click="goToNews">
          <span>Back to News</span>
          <span>
            <v-icon name="chevron-left"></v-icon>
          </span>
        </p>
        <p v-if="auth" @click="num=2">
          <span>More</span>
          <span>
            <v-icon name="chevron-down"></v-icon>
          </span>
        </p>
        <!-- <p v-else @click="showLoginModal">
          <span>More</span>
          <span>
            <v-icon name="chevron-down"></v-icon>
          </span>
        </p>-->
      </div>
    </div>
  </div>
</template>



<script>
import AssetSearch from "@/components/utils/asset-search.vue";

export default {
  components: {
    AssetSearch
  },

  created() {
    this.getUnibitOpinions();
  },

  data() {
    return {
      assetNewsList: [],
      num: 1,
      show: false
    };
  },

  computed: {
    auth() {
      return this.$store.getters.isLogin && this.getWindowLocalStorage("token");
    }
  },

  methods: {
    getUnibitOpinions() {
      this.$store
        .dispatch("getUnibitOpinions")
        .then(res => res.data)
        .then(res => {
          console.log(res);
          this.assetNewsList = res;
        });
    },

    formatDateTime(datetime) {
      return datetime ? datetime.split("T")[0] : "";
    },

    setSearchTicker(ticker) {
      console.log("from news page", ticker);
      this.$store.commit("setAssetInfo", ticker);
      // this.$router.push({ name: "insight-page" });
    },

    goToNews() {
      this.$router.push({ name: "news-page" });
    },

    showFullOpinion() {
      if (this.auth) {
        this.show = !this.show;
      } else {
        // this.showLoginModal();
      }
    }
  }
};
</script>


<style scoped>
/* css for desktop */

.search-section {
  width: 240px;
  padding: 3px 0px;
  margin: 1rem auto;
  margin-left: 21px;
}

.search-section > span {
  margin-right: 2px;
}

.icon-search {
  height: 16px;
  width: 16px;
  stroke: #5a5c5c;
  opacity: 0.49;
}

.header {
  margin-left: 21px;
  margin-top: 1.25rem;
  font-family: Avenir;
  /* align-items: center; */
}

.header span {
  opacity: 0.63;
  font-family: Avenir-Roman;
  height: 100%;
  font-size: 16px;
  color: #f5a623;
}

.header span:hover {
  cursor: pointer;
}

.header > div > span:first-child {
  text-decoration: underline;
}

h1 {
  margin-left: 0.25rem;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.71px;
  color: #4a4a4a;
}

.main-content {
  margin: 1.5rem 21px;
  margin-bottom: 3rem;
}

.opinion-news {
  padding-bottom: 1.5rem;
  border-bottom: dashed 1px #979797;
}

.pic img {
  height: 70%;
  width: 90%;
}

.pic > div {
  margin-top: 1.5rem;
}

.pic > div > span {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.47px;
  padding: 4px 18px;
  color: #16abbd;
  border-radius: 4px;
  border: solid 1px #16abbd;
}

.opinion-news > div.col-9 {
  margin-top: 0.75rem;
}

.opinion-news > div > #NewsSource {
  opacity: 0.34;
  font-family: Raleway;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.47px;
  color: #4a4a4a;
}

.opinion-news > div > #NewsTitle {
  margin-top: 0.25rem;
  font-family: Raleway;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.53px;
}

.opinion-news > div > #NewsTitle > a:first-child {
  color: #4a4a4a;
}

.opinion-news > div > #NewsContent {
  margin-top: 0.25rem;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.41px;
  color: #4a4a4a;
}

.opinion-news > div > #NewsDateTime {
  margin-top: 0.25rem;
  opacity: 0.38;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.41px;
  color: #4a4a4a;
}

.icon-chevron-down,
.icon-chevron-left {
  width: 16px;
  height: 16px;
}

.login-hint {
  font-family: Avenir;
  font-size: 14px;
  letter-spacing: 0.59px;
  color: #f5a623;
  margin-top: 0.75rem;
}

.login-hint:hover {
  cursor: pointer;
}

.login-hint > span:first-child {
  text-decoration: underline;
}

.footer-links {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  opacity: 0.63;
  font-family: Avenir-Roman;
  font-size: 14px;
  letter-spacing: 0.71px;
  color: #f5a623;
}

.footer-links:hover {
  cursor: pointer;
}

.footer-links > p > span:first-child {
  text-decoration: underline;
}

@media (min-width: 576px) {
  .search-section {
    display: flex;
    width: 480px;
    /* border-bottom: solid 0.4px #979797; */
    padding: 12px 0px;
    margin: 1rem auto;
    margin-left: 140px;
  }

  .search-section > span {
    margin-right: 6px;
  }

  .icon-search {
    height: 16px;
    width: 16px;
    stroke: #5a5c5c;
    opacity: 0.49;
  }

  .header {
    margin-left: 140px;
    margin-top: 2rem;
    font-family: Avenir;
    /* align-items: center; */
  }

  .header span {
    opacity: 0.63;
    font-family: Avenir-Roman;
    height: 100%;
    font-size: 24px;
    color: #f5a623;
  }

  .header span:hover {
    cursor: pointer;
  }

  .header > div > span:first-child {
    text-decoration: underline;
  }

  h1 {
    margin-left: 1rem;
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 1.06px;
    color: #4a4a4a;
  }

  .main-content {
    margin: 2rem 140px;
    margin-bottom: 3rem;
  }

  .opinion-news {
    padding-bottom: 1rem;
    border-bottom: dashed 1px #979797;
  }

  .pic > div {
    margin-top: 1.5rem;
  }

  .pic > div > span {
    font-family: Avenir;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.47px;
    padding: 4px 18px;
    color: #16abbd;
    border-radius: 4px;
    border: solid 1px #16abbd;
  }

  .opinion-news > div.col-9 {
    margin-top: 1rem;
  }

  .opinion-news > div > #NewsSource {
    opacity: 0.34;
    font-family: Raleway;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.47px;
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsTitle {
    margin-top: 0.5rem;
    font-family: Raleway;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.53px;
  }

  .opinion-news > div > #NewsTitle > a:first-child {
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsContent {
    margin-top: 0.5rem;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsDateTime {
    margin-top: 0.5rem;
    opacity: 0.38;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .pic img {
    height: 150px;
    width: 200px;
  }

  .icon-chevron-down,
  .icon-chevron-left {
    width: 24px;
    height: 28px;
  }

  .login-hint {
    font-family: Avenir;
    font-size: 20px;
    letter-spacing: 0.59px;
    color: #f5a623;
    margin-top: 1rem;
  }

  .login-hint:hover {
    cursor: pointer;
  }

  .login-hint > span:first-child {
    text-decoration: underline;
  }

  .footer-links {
    margin-top: 1.5rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    opacity: 0.63;
    font-family: Avenir-Roman;
    font-size: 24px;
    letter-spacing: 0.71px;
    color: #f5a623;
  }

  .footer-links:hover {
    cursor: pointer;
  }

  .footer-links > p > span:first-child {
    text-decoration: underline;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insight-pages/insight-opinion-page.vue